import React from "react";
import { DropGameResult } from "./DropGameRun.tsx";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";
import { format } from "../../Shared/i18n/format.ts";

interface DropGameSummaryProps {
    result: DropGameResult;
    /** Best score on this device, after this game. */
    best: number | null;
    isNewBest: boolean;
    onPlayAgain(): void;
    /** Back to the fact picker, so the next game can use other operations (ADR 0098 §1). */
    onChangeFacts(): void;
}

/** Game over: the score, the level, and every fact that landed with its answer. */
export function DropGameSummary({ result, best, isNewBest, onPlayAgain, onChangeFacts }: DropGameSummaryProps) {
    const t = useTranslation();

    return (
        <div className="quizSummary">
            <p className="quizSummaryCounts">{t("flashCards.gameOver")}</p>
            <p className="quizSummaryScore">{result.cleared}</p>
            <p className="quizSummaryScoreLabel">{t("flashCards.gameClearedCaption")}</p>
            <p className="quizSummaryCounts">
                {format(t("flashCards.gameReachedTemplate"), { level: result.level, wrong: result.wrongGuesses })}
            </p>

            {best !== null && (
                <p className={`quizSummaryBest${isNewBest ? " quizSummaryBest--new" : ""}`}>
                    {isNewBest ? t("flashCards.newBest") : format(t("flashCards.yourBestTemplate"), { n: best })}
                </p>
            )}

            {result.landed.length > 0 && (
                <div className="quizSummaryMisses">
                    <h3>{t("flashCards.worthAnotherLookHeading")}</h3>
                    <ul>
                        {result.landed.map((fact, i) => (
                            <li key={i}>
                                <span className="quizSummaryMissProblem">
                                    {fact.front} = {fact.answer}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <button type="button" className="quizPlayAgain" onClick={onPlayAgain}>
                {t("flashCards.playAgain")}
            </button>
            <button type="button" className="quizChangeMode" onClick={onChangeFacts}>
                {t("flashCards.dropChangeFacts")}
            </button>
        </div>
    );
}
